import React from "react";
import { useNavigate } from "react-router-dom";

const PagoFallido = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 py-8">
      <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-10 text-center max-w-md w-full border border-gray-300">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-black mb-4">
          Pago fallido
        </h2>
        <p className="text-gray-600 mb-6">
          No pudimos procesar tu pago. Podés intentar de nuevo o usar otro método.
        </p>
        <button
          onClick={() => navigate("/carrito")}
          className="bg-black text-white px-6 py-3 rounded-xl font-semibold hover:bg-gray-900 transition w-full sm:w-auto"
        >
          Volver al carrito
        </button>
      </div>
    </div>
  );
};

export default PagoFallido;
